export default __webpack_public_path__ + "static/media/ornament_4.809cf507.png";